import { type ReactElement } from 'react';
import { Link, Navigate } from 'react-router';
import { useSession } from '../coquille/ContexteSession.js';
import { CHEMINS } from '../routes.js';

/**
 * MES ESPACES — le carrefour.
 *
 * ── UN SEUL ESPACE : ON N'OBLIGE PAS A CHOISIR ──────────────────────────
 *
 * Presenter une liste d'un element pour la faire cliquer est une etape sans
 * information. On y va directement.
 *
 * ── AUCUN ESPACE : CE N'EST PAS UNE ERREUR ──────────────────────────────
 *
 * Un compte existe avant d'etre rattache. L'ecran DIT ce qui manque et a qui
 * s'adresser -- une liste vide sans explication laisse croire a une panne.
 */
export function MesEspaces(): ReactElement {
  const { etat } = useSession();
  if (etat.phase !== 'connecte') return <Navigate to={CHEMINS.connexion} replace />;
  const espaces = etat.vue.locataires;

  // LE RACCOURCI CEDE DEVANT LE CARREFOUR. Aller droit a l unique espace
  // epargne un clic vide -- tant que cette page n a rien d autre a montrer.
  // Depuis 29-B elle porte l entree du monde plateforme [28-BU], et un
  // operateur n est membre d aucun client qu il cree : il n a donc qu UN
  // espace, et le raccourci le renvoyait aussitot dans le client, sans
  // jamais lui laisser voir la porte. Le replace le rendait meme invisible.
  const operateur = etat.vue.roles_plateforme.includes('exploitation');
  if (espaces.length === 1 && !operateur) {
    return <Navigate to={CHEMINS.espace(espaces[0]!.code)} replace />;
  }

  return (
    <div className="plein-centre">
      <div>
        <h1>Mes espaces</h1>
        <p className="discret">
          Bonjour {etat.vue.utilisateur.nom}
        </p>
      </div>
      {/* MONDE PLATEFORME [28-BU]. Un operateur n est membre d aucun des
          clients qu il cree : sans ce lien, il n aurait aucune porte ici.
          L AFFICHAGE N EST PAS UNE AUTORISATION -- la route API garde son
          propre controle du role « exploitation ». */}
      {operateur ? (
        <Link className="carte" to={CHEMINS.plateforme}>
          <h3>Administration Anelya</h3>
          <p className="discret">Creer et administrer les clients.</p>
        </Link>
      ) : null}
      {espaces.length === 0 ? (
        <div className="carte etat-vide">
          <h3>Aucun espace ne vous est ouvert</h3>
          <p className="discret">
            Votre compte existe, mais il n’est rattaché à aucun espace de travail.
            Demandez à un propriétaire d’espace de vous y ajouter.
          </p>
        </div>
      ) : (
        <ul className="grille" style={{ width: '100%', maxWidth: '48rem' }}>
          {espaces.map((l) => (
            <li key={l.code}>
              <Link to={CHEMINS.espace(l.code)} className="carte"
                    style={{ display: 'block', color: 'inherit' }}>
                <strong>{l.nom}</strong>
                {/* LE ROLE VIENT DE L'API, il n'est pas deduit ici. */}
                <span className="etiquette" style={{ marginTop: 'var(--espace-2)' }}>
                  {l.role}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
